import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";
import ht from "./locales/ht.json";
import pt from "./locales/pt.json";
import he from "./locales/he.json";

// Launch languages. `rtl: true` drives document direction.
export const LANGUAGES = [
  { code: "en", labelKey: "language.english", native: "English", rtl: false },
  { code: "es", labelKey: "language.spanish", native: "Español", rtl: false },
  { code: "ht", labelKey: "language.haitianCreole", native: "Kreyòl Ayisyen", rtl: false },
  { code: "pt", labelKey: "language.portuguese", native: "Português", rtl: false },
  { code: "he", labelKey: "language.hebrew", native: "עברית", rtl: true },
];

export const SUPPORTED_CODES = LANGUAGES.map((l) => l.code);
export const RTL_CODES = LANGUAGES.filter((l) => l.rtl).map((l) => l.code);

export function isRTL(code) {
  return RTL_CODES.includes(code);
}

// Apply <html dir/lang> so RTL languages (Hebrew) mirror correctly and LTR
// languages restore immediately. Called on init + every language change.
export function applyDirection(code) {
  const dir = isRTL(code) ? "rtl" : "ltr";
  const el = document.documentElement;
  el.setAttribute("dir", dir);
  el.setAttribute("lang", code);
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
      ht: { translation: ht },
      pt: { translation: pt },
      he: { translation: he },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_CODES,
    nonExplicitSupportedLngs: true, // "es-MX" -> "es", "pt-BR" -> "pt"
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "bl_lang",
      caches: ["localStorage"],
    },
  });

applyDirection(i18n.resolvedLanguage || "en");
i18n.on("languageChanged", (lng) => applyDirection(lng));

export default i18n;
